import { useState, useEffect } from 'react';
import { ReportesService } from '../services/reportesService';

export interface UseCorrelatrivoReturn {
  siguienteNumero: string | null;
  cargando: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

/**
 * Hook para obtener el siguiente número de correlativo automático
 */
export const useCorrelativo = (): UseCorrelatrivoReturn => {
  const [siguienteNumero, setSiguienteNumero] = useState<string | null>(null);
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchSiguienteNumero = async () => {
    setCargando(true);
    setError(null);
    
    try {
      const numero = await ReportesService.obtenerSiguienteNumero();
      setSiguienteNumero(numero);
    } catch (err: any) {
      setError(err.message || 'Error al obtener correlativo');
      setSiguienteNumero(null);
    } finally {
      setCargando(false);
    }
  };

  useEffect(() => {
    // Obtener correlativo al montar el componente
    fetchSiguienteNumero();
  }, []);

  return {
    siguienteNumero,
    cargando,
    error,
    refetch: fetchSiguienteNumero
  };
};

export default useCorrelativo;
